import React from 'react';
import { Link } from 'react-router-dom';
import { useSwiperInit } from '../../hooks/useSwiperInit';

function Hero() {
    useSwiperInit(); // ← Se elimina la asignación a variable no usada

    return (
        <section className="hero-slider hero-style-1">
            <div className="swiper-container">
                <div className="swiper-wrapper">
                    {/* Slide 1 - Family Law */}
                    <div className="swiper-slide">
                        <div 
                            className="slide-inner slide-bg-image" 
                            style={{backgroundImage: "url('/assets/images/slider/slide-1.jpg')"}}
                        >
                            <div className="container">
                                <div className="slide-title" data-swiper-parallax="300">
                                    <h2>Our Independence Makes the Difference</h2>
                                </div>
                                <div className="slide-text" data-swiper-parallax="400">
                                    <p>Nationally Established. Internationally Recognized</p>
                                </div>
                                <div className="clearfix"></div>
                                <div className="slide-btns" data-swiper-parallax="500">
                                    <Link to="/contact" className="theme-btn">Free Consultation</Link> 
                                </div>
                                <div className="video-btns">
                                    <a href="https://www.youtube.com/embed/7e90gBu4pas?autoplay=1" className="video-btn" data-type="iframe">
                                        <i className="fi flaticon-play"></i>
                                    </a> 
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Slide 2 - Personal Injury */}
                    <div className="swiper-slide">
                        <div 
                            className="slide-inner slide-bg-image" 
                            style={{backgroundImage: "url('/assets/images/slider/slide-2.jpg')"}}
                        >
                            <div className="container">
                                <div className="slide-title" data-swiper-parallax="300">
                                    <h2>Our Independence Makes the Difference</h2>
                                </div>
                                <div className="slide-text" data-swiper-parallax="400">
                                    <p>Nationally Established. Internationally Recognized</p>
                                </div>
                                <div className="clearfix"></div>
                                <div className="slide-btns" data-swiper-parallax="500">
                                    <Link to="/contact" className="theme-btn">Free Consultation</Link> 
                                </div>
                                <div className="video-btns">
                                    <a href="https://www.youtube.com/embed/7e90gBu4pas?autoplay=1" className="video-btn" data-type="iframe">
                                        <i className="fi flaticon-play"></i>
                                    </a> 
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Slide 3 - Criminal Law */}
                    <div className="swiper-slide">
                        <div 
                            className="slide-inner slide-bg-image" 
                            style={{backgroundImage: "url('/assets/images/slider/slide-3.jpg')"}}
                        >
                            <div className="container">
                                <div className="slide-title" data-swiper-parallax="300">
                                    <h2>Our Independence Makes the Difference</h2>
                                </div>
                                <div className="slide-text" data-swiper-parallax="400">
                                    <p>Nationally Established. Internationally Recognized</p>
                                </div>
                                <div className="clearfix"></div>
                                <div className="slide-btns" data-swiper-parallax="500">
                                    <Link to="/contact" className="theme-btn">Free Consultation</Link> 
                                </div>
                                <div className="video-btns">
                                    <a href="https://www.youtube.com/embed/7e90gBu4pas?autoplay=1" className="video-btn" data-type="iframe">
                                        <i className="fi flaticon-play"></i>
                                    </a> 
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Slide 4 - Business Law */}
                    <div className="swiper-slide">
                        <div 
                            className="slide-inner slide-bg-image" 
                            style={{backgroundImage: "url('/assets/images/slider/slide-4.jpg')"}}
                        >
                            <div className="container">
                                <div className="slide-title" data-swiper-parallax="300">
                                    <h2>Our Independence Makes the Difference</h2>
                                </div>
                                <div className="slide-text" data-swiper-parallax="400">
                                    <p>Nationally Established. Internationally Recognized</p>
                                </div>
                                <div className="clearfix"></div>
                                <div className="slide-btns" data-swiper-parallax="500">
                                    <Link to="/contact" className="theme-btn">Free Consultation</Link> 
                                </div>
                                <div className="video-btns">
                                    <a href="https://www.youtube.com/embed/7e90gBu4pas?autoplay=1" className="video-btn" data-type="iframe">
                                        <i className="fi flaticon-play"></i>
                                    </a> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Pagination Container - Swiper generará los botones aquí */}
                <div className="swiper-cust-pagination swiper-pagination-clickable swiper-pagination-bullets"></div>

                {/* Navigation Arrows */}
                <div className="swiper-button-next"></div>
                <div className="swiper-button-prev"></div>
            </div>
        </section>
    );
}

export default Hero;